// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"fad2c632","101":"6e7001a5","272":"42883640","736":"7f389877","924":"c069e169","977":"e1122290"}[chunkId] + ".css";
};